import { Link } from "react-router-dom";

import { ContentScroll } from "features/layout/components";

import { Button } from "common/components/ui/Button";
import { formatNumber } from "common/helpers/utils";

import type { ReactNode } from "react";

//sources that know how many leads they'll bring in pass leadCount, which is
//shown in the footer and gates the create button. the ones that don't - csv and
//crm imports - decide when they're ready to be created themselves
type ScrollAndFooterProps = {
  children: ReactNode;
  onCreate: () => void;
  isCreatingSource: boolean;
} & (
  | { leadCount: number; isCreateDisabled?: never }
  | { leadCount?: never; isCreateDisabled: boolean }
);

export default function ScrollAndFooter({
  children,
  leadCount,
  onCreate,
  isCreatingSource,
  isCreateDisabled,
}: ScrollAndFooterProps) {
  const hasLeadCount = leadCount !== undefined;

  return (
    <>
      <ContentScroll className="p-4">{children}</ContentScroll>
      <div className="flex border-t py-2.5 px-4 border-t-black-200 justify-between items-center">
        <Button variant="secondary-black" asChild>
          {/* @ts-expect-error: router types are wrong, both link and navigate accept a -1 to go back */}
          <Link to={-1}>Cancel</Link>
        </Button>

        {hasLeadCount && (
          <span className="text-button-xs text-black-400">
            {leadCount ? formatNumber(leadCount) : "No"} leads found
          </span>
        )}
        <Button
          onClick={onCreate}
          disabled={hasLeadCount ? !leadCount : isCreateDisabled}
          isLoading={isCreatingSource}
        >
          Create source
        </Button>
      </div>
    </>
  );
}
